(function () {
    "use strict";

    angular.module("physicalFairs")
        .controller("PhysicalFairSeminarsFormController", PhysicalFairSeminarsFormController);
    

        PhysicalFairSeminarsFormController.$inject = ['$uibModal', '$filter', '$scope','SellerService' ,'ExpoService', 'seminars', '$state','toastr','$stateParams', 'expo'];


    function PhysicalFairSeminarsFormController( $uibModal, $filter, $scope, SellerService, ExpoService, seminars, $state, toastr, $stateParams, expo) {
        
        var vm = this;

        vm.seminars              = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.expoSelected          = '';
        vm.citySelected          = '';
        vm.platform_theme        = '';
        vm.goToList              = goToList;
        vm.cities                = [];
        vm.seminars              = [{
            id:                 '', 
            expo_location_id:   '',
            title:              '',
            description:        '',
            institution:        '',
            logo_url:           '',
            language:           '',
            presenters:         '',   
            start_datetime_utc: '',
            end_datetime_utc:   '',
        }];
        vm.delete_seminars       = [];
        vm.index                 = 0;
        vm.expo                  = '';

        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value:'All'}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'Yes', value:1};
        vm.getSellers            = getSellers;
        vm.mountSeminar          = mountSeminar;
        vm.store                 = store;
        vm.save                  = save;
        vm.addSession            = addSession;
        vm.addSeminar            = addSeminar;
        vm.removeSession         = removeSession;
        vm.uploadHandler         = uploadHandler;
        vm.imageCrop             = imageCrop;
        vm.uploadPhoto           = uploadPhoto;
        vm.goUpdate              = goUpdate;
        vm.removeSeminar         = removeSeminar;
        vm.selectCities          = selectCities;
        vm.countResult           = 0;
        vm.registersInEventSelected = {name:'No', id:0};
        vm.registersInEventList = [{id:'all', name:'All'},{id:1, name:'Yes'},{id:0,name:'No'}];
        vm.platformThemes = [{id:'blue'},{id:'red'},{id:'orange'},{id:'yellow-blue'},{id:'yellow-green'},{id:'green'},{id:'green-blue'},{id:'blue-golden'},{id:'yellow-black'}]
        vm.expo                  = expo
        function activate() {
            if ($stateParams.hasOwnProperty('msg') && $stateParams.msg) {
                if ($stateParams.error) {
                    toastr.error(`${$stateParams.msg}`);
                } else {
                    toastr.success(`${$stateParams.msg}`);
                }
                
            }
            vm.getSellers();
            vm.mountSeminar();
        }

        function removeSeminar(index){
            vm.delete_seminars.push({id: vm.seminars[index].id});
            vm.seminars.splice(index, 1);
        }

        async function selectCities () {
            vm.cities = []

            let query = {}
            query['expos_ids'] = [vm.expoSelected]
            
            await ExpoService.getExposCities(query).then(function(response){
                    vm.cities = response.data;
            }).catch(function(err) {

            });
        }

        function getSellers() {
            SellerService.getAllVirtualFair().then(function(response){
                vm.seller = response.data;
                vm.seller.unshift({id: 498, name:"<span class='text-muted'>No Representative</span>"});
                vm.seller.unshift({id: -1,name:"All"});
            }).catch(function(err) {

            });
        }

        async function mountSeminar(){
            console.log(seminars)
            if(seminars && seminars.length > 0){
                vm.virtual_fair = seminars[0].virtual_fair;
                vm.seminars = [];

                vm.expoSelected = seminars[0].location.expo_id
                await vm.selectCities()
                vm.citySelected = seminars[0].expo_location_id

                for(let i = 0; i < seminars.length; i++){       

                    
                    vm.seminars.push({
                        id: seminars[i].id,
                        order: seminars[i].order,
                        title: seminars[i].title,
                        institution: seminars[i].institution,
                        description: seminars   [i].description,
                        show_date: seminars[i].show_date == 1,
                        logo_url: seminars[i].logo_url,
                        language: seminars[i].language,
                        presenters: seminars[i].presenters,
                        expo_location_id: vm.citySelected,
                        update: true,
                        start_datetime_utc: new Date(seminars[i].start_datetime_utc),
                        end_datetime_utc: new Date(seminars[i].end_datetime_utc),
                        // sessions: seminars[i].slots.map(elem => {
                        //     return {
                        //         button_label: elem.button_label,
                        //         end_datetime_utc: new Date(elem.end_datetime_utc),
                        //         expo_virtual_fair_seminar_id: elem.expo_virtual_fair_seminar_id,
                        //         id: elem.id,
                        //         order: elem.order,
                        //         start_datetime_utc: new Date(elem.start_datetime_utc),
                        //         url: elem.url
                        //     }
                        // })
                    })
                }
            }
        }



        function addSession(index) {
            vm.seminars[index].sessions.push({
                button_label:   '',
                url:            '',
                order:          ''
            });
        }

        function addSeminar(){
            vm.seminars.push({

                expo_location_id:   '',
                title:              '',
                description:        '',
                institution:        '',
                logo_url:           '',
                language:           '',
                presenters:         '',   
                start_datetime_utc: '',
                end_datetime_utc:   '',
                update: false,
            });
        }

        function removeSession(session, index){
            if(typeof vm.seminars[index].sessions === 'object' && vm.seminars[index].sessions.length > 1) {                
                vm.seminars[index].sessions.splice(vm.seminars[index].sessions.indexOf(session), 1);
            }
        }

        function uploadPhoto(index) {
            vm.index = index;
            angular.element('#accountProfilePhoto').trigger('click');
        }

        function uploadHandler(e) {
            if (e.currentTarget.files.length) {
                var file = e.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        vm.imageCrop(e.target.result);
                    });
                };
                reader.readAsDataURL(file);
            }
            angular.element(e.target).val(null);
        }   

        function imageCrop(uploaded) {
            $uibModal.open({
                size: 'sm',
                backdrop  : 'static',
                templateUrl: 'templates/physicalfairs/reports/pre-registrations/account/form/crop.modal.html',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var cropModal = this;
                    cropModal.cancel = $uibModalInstance.close;
                    cropModal.save = save;
                    cropModal.uploaded = uploaded;

                    function save() {
                        vm.seminars[vm.index].logo = cropModal.cropped;
                        cropModal.cancel();
                    }
                }],
                controllerAs: 'cropModal',
            });
        }

        function save(){
            if(seminars && seminars.length){
                update();
            }else{
                store();
            }
        }
        

        function store() {
            if(!$scope.reportFormStudent.$valid){
                return;
            }
            for(var i = 0; i < vm.seminars.length; i++){                
                vm.seminars[i].expo_location_id = vm.citySelected;
                // vm.seminars[i].start_datetime_utc = moment(vm.seminars[i].start_datetime_utc).format("YYYY-MM-DD HH:mm");
                // vm.seminars[i].end_datetime_utc = moment(vm.seminars[i].end_datetime_utc).format("YYYY-MM-DD HH:mm");
            }
            ExpoService.storeSeminar(vm.seminars).then(function(response){
                alertify.success('Seminar successfull created!');
                // vm.goUpdate(vm.seminars[0].virtual_fair_id);
                vm.goToList()
            }).catch(function(err) {
            });
        }

        async function goToList () {
            return await $state.go('root.physicalfairs.seminars');
        }

        async function goUpdate (id) {
            return await $state.go('root.physicalfairs.seminars.form', {id: id});
        }

        function update() {
           

            for(var i = 0; i < vm.seminars.length; i++){                
                vm.seminars[i].expo_location_id = vm.citySelected;
                vm.seminars[i].start_datetime_utc = moment(vm.seminars[i].start_datetime_utc).format("YYYY-MM-DD HH:mm");
                vm.seminars[i].end_datetime_utc = moment(vm.seminars[i].end_datetime_utc).format("YYYY-MM-DD HH:mm");

                 

                // if (vm.seminars[i].update) {
                //     VirtualFairService.updateSeminar(vm.seminars[i], vm.seminars[i].id).then(function(response){
                //         alertify.success('Seminar successfull updated!');
                //     }).catch(function(err) {
                //     });
                // } else {
                //     VirtualFairService.storeSeminar(vm.seminars[i]).then(function(response){
                //         alertify.success('Seminar successfull created!');                        
                //     }).catch(function(err) {
                //     });
                // }
            }

            ExpoService.updateSeminar(vm.seminars).then(function(response){
                alertify.success('Seminar successfull updated!');
            }).catch(function(err) {
            }); 

            vm.goToList();
           
        }

       
        activate();
    }
})();
